import { createAsyncThunk } from '@reduxjs/toolkit'
import { SubscriptionWithDiscount } from '../../types/SubscriptionWithDiscounts'
import { Extra } from '../../redux/store'

export const fetchSubscriptionData = createAsyncThunk<SubscriptionWithDiscount, void, Extra>(
  'fetchSubscriptionData',
  async (params: void, { extra }) => {
    return extra.appApi.fetchSubscriptionData()
  }
)
